import {useAppSelector} from "@Hooks/selector/useAppSelector";

/**
 * Returns isMobile boolean from page state
 */
export default function useAdditionalInfo(): boolean {
    return useAppSelector((state) => state?.mobile.additionalInfoActive)
}